import React,{useState, useEffect} from 'react'
import { Box,styled, Typography, Button, Stack, Skeleton, Grid, IconButton, TextField, MenuItem, Select, FormControl, Divider,Modal, CircularProgress } from "@mui/material";
import Disclaimer from '../../img/disclaimer.png';
import Protection from '../../img/products/Protection.png';
import InfiniteIcon from '../../img/products/infinite.png';
import BackArrow from '../../img/products/BackArrow.png';
import { ReactComponent as ModalCloseIcon } from '../../img/modalCloseIcon.svg';
import '../../index.css';
import { useParams, useNavigate } from 'react-router-dom';
import { ApiService } from '../../API/AxiosInstance';
import UnsubscribeIcon from '../../img/unsubscribeIcon.png';
import PdfIcon from '../../img/products/Pdf.png';
import dayjs from 'dayjs';
import moment from 'moment';
import Chart from 'react-apexcharts';
import EmptyChart from '../EmptyChart';
import TimelineView from './Timeline';
import '../chart.css';
import ToastAlert from '../../utils/Toaster';
import OnboardingStatusHook from '../customhook/onboardingStatus';
import { changeRiskTypeName } from './UpcomingEvents';
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import { captureException } from '@sentry/react';
import { twoDecimalRegex, allowAllExceptAngleBrackets } from '../../utils/validation';
import MainLayout from '../../components/MainLayout';
import { colors } from '../../Theme/tokens';
import PrimaryButton from '../../Theme/styled/PrimaryButton';
import IdleCashField from '../../components/IdleCashField';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: "80%", sm: '70%', md: '50%' },
    maxWidth:"879px",
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  export const StyledErrorText = styled(Typography)({
    color: colors.error.main,
    fontSize: "0.85rem",
    margin: "4px 0"
})



export default function ProductDetails() {
    const today = new Date()
    const formattedToday = moment(today).format('YYYY-MM-DD HH:mm:ss')
    const {id} = useParams()
    const navigate = useNavigate()
    const [product, setProduct] = useState({})
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : ''
    const [type, setType] = useState('')
    const [lockingPeriod, setLockingPeriod] = useState('')
    const [riskRating, setRiskRating] = useState('')
    const [projectedReturns, setProjectedReturns] = useState('')
    const [videoUrl, setVideoUrl] = useState([])
    const [factSheetUrl, setFactSheetUrl] = useState("")
    const [disclaimer, setDisclaimer] = useState('')
    const [iconUrl, setIconUrl] = useState('')
    const [sma, setSma] = useState({isEligible: false, description:""})
    const [timeline, setTimeLine] = useState([])
    const [isProductSubscribed, setIsProductSubscribed] = useState(false)
    const [isSubscribeClicked, setIsSubscribeClicked] = useState(false)
    const [prices, setPrices] = useState([])
    const [graphData, setGraphData] = useState({})
    const [chartData, setChartData] = useState([])
    const [duration, setDuration] = useState('1 Year')
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
    const [formValues, setFormValues] = useState({
        investedAmt: '',
        allocationType: '',
        productName: '',
        productDescription: '',
    });
    const [formErrors, setFormErrors] = useState({
        investedAmt: '',
        allocationType: '',
    });
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''

    const { onboardingStatusText, apiLoading, error } = OnboardingStatusHook(`${process.env.REACT_APP_BASE_URL}users/${userId}/onboarding/status`, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}});
    const [idleCash,setIdleCash] = useState(0.00)
    const isSubscribeDisabled = (formValues?.investedAmt <=''  || parseFloat(formValues?.investedAmt) < 100 || idleCash < parseFloat(formValues?.investedAmt) ? true : false)
    console.log("isSubscribeDisabled ",isSubscribeDisabled)
        useEffect(() => {
          if(userId)  getIdleCash()
        },[userId])
    
        const getIdleCash =async () => {
          try {
            const response = await ApiService().get(`users/${userId}/idle-cash`)
            console.log("idlecash ",response)
            setIdleCash(response?.data?.idleCashPortfolio?.amount)
          } catch(error) {
            console.log("error ",error)
          }
        }


    const handleDuration = (value) => {
        setDuration(value)
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if(name == "investedAmt") {
          console.log("value ",value)
            if(twoDecimalRegex?.test(value)) {
              setFormValues({...formValues,[name]: value});
              if(parseFloat(value) > parseFloat(idleCash)) {
                console.log("withthththth")
                setFormErrors(prev=>({...prev, investedAmt: 'Entered amount exceeds idle cash'}))
              } else if(!value || value < 100) {
                setFormErrors(prev=>({...prev, investedAmt: 'Invested amount is required and must be 100 or above'}))
              }
              else {
                setFormErrors(prev=>({...prev, investedAmt: ""}))
              }
            }
            return
        } else if(name == "productName" || name == "productDescription") {
            if(allowAllExceptAngleBrackets?.test(value)) {
              setFormValues({...formValues,[name]: value});
            }
        } else {
          setFormValues({...formValues,[name]: value});
        }
       
        setFormErrors(prev=>({...prev, [name]: ""}))
    };

    React.useEffect(() => {
        window.scrollTo(0,0)
        return () => localStorage.removeItem('fromPortfolio')
      },[])

      useEffect(() => {
        (async () => {
            setLoading(true)
            await ApiService().get(`products/${id}`).then(res => {
                if(res?.data?.product?.id) {
                    setProduct(res.data.product)
                    setLoading(false)
                }
            })
                .catch(err => {
                    setLoading(false)
                    captureException(error)
                })
        })()

    }, [])

    const validate = () => {
        let isValid = true;
        const errors = {
          investedAmt: '',
          allocationType: '',
        };
    
        if (!formValues.investedAmt || formValues.investedAmt < 100) {
          errors.investedAmt = 'Invested amount is required and must be 100 or above';
          isValid = false;
          console.log("idleCash ",idleCash, formValues?.investedAmt, formValues?.investedAmt > idleCash )
        } else if(parseFloat(formValues?.investedAmt) < parseFloat(0)) {
          errors.investedAmt = 'Invested amount should be greater than 0'
          isValid = false
        } 
        else if(parseFloat(formValues?.investedAmt) > parseFloat(idleCash)) {
          errors.investedAmt = 'Entered amount exceeds idle cash'
          isValid = false
        }
         else {
          errors.investedAmt = ''
          isValid = true
        }
    
        if (!formValues.allocationType) {
          errors.allocationType = 'Allocation type is required';
          isValid = false;
        }
    
        setFormErrors(errors);
        return isValid;
    }
    console.log("ormValues?.investedAmt ",formValues?.investedAmt)

    const handleSubmit = async() => {
        const validation = validate()
        if(!validation) return
        let reqData = {
            userId: userData?.sub_id,
            productId: parseInt(id),
            investedAmt:parseInt(formValues.investedAmt),
            allocationType:formValues.allocationType,
            customName: formValues?.productName,
            customDescription: formValues?.productDescription,
            isActive: true,
        }
        try {
            const response = await ApiService().post('portfolios', reqData)
            if(response) {
              setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
              setTimeout(()=>{
                setToastStatus({color:'',status:false, message:""})
                navigate('/SuccessSubscribed')
            },3000)
            }
        } catch (error) {
          setToastStatus({color:'red',status:true,message: error?.response?.data?.message,icon:'close'})
          setTimeout(()=>{
            setToastStatus({color:'',status:false, message:""})
        },3000)
        captureException(error)
        }
    }


    function getId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url?.match(regExp);
        if (match && match[2].length == 11) {
            return match[2];
        } else {
            return 'error';
        }
    }

    const handleSubscribe = () => {
        setIsSubscribeClicked(prev=> !prev)
    }

    const handleUnsubscribe = () => {
        
    }

    const handleClose = () => {
    setOpen(false);
    };

    const getChartData = async () => {
        try {
          const response = await ApiService().get(`users/${ userData?.sub_id}/products/${id}/timeseries`)
          if(response?.data) {
            if(response?.data?.data?.length > 0) {
              setChartData(response.data.data)
            }
          }
          
        } catch (error) {
          captureException(error)
        }
    };

    const checkSubscribedOrNot = async () => {
        try {
          const response = await ApiService().get(`portfolios/portfolio-details?userId=${ userData?.sub_id}&productId=${id}`)
          if(response?.data) {
           setIsProductSubscribed(true)
          }
          
        } catch (error) {
          setIsProductSubscribed(false)
          console.log("checkSubscribedOrNot ",error)
          captureException(error)
        }
    };
    useEffect(() => {
        checkSubscribedOrNot()
    },[userData?.sub_id])

    useEffect(() => {
        if(userData?.sub_id && isProductSubscribed) getChartData()
    },[ userData?.sub_id, isProductSubscribed])

      useEffect(() => {
        if(prices?.length > 0 && isProductSubscribed) {
          const chartDatas = {
            options: {
              chart: {
                type: 'area',
                toolbar: {
                  show: false,
                },
                zoom: {
                    enabled: false, 
                },
              },
              padding: {
                top: '100px',
                bottom: '100px',
              },
              dataLabels: {
                enabled: false,
              },
              yaxis: {
                tickAmount: 4,
                labels: {
                    style: {
                        fontWeight: '600',
                        colors: colors.text.primary,
                      },
                      formatter: function (value) {
                        return '$ ' + Math.round(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                      },
                },
              },
              xaxis: {
                type: 'category',
                tickAmount: 3,
                labels: {
                  format: 'MMM yy',
                  formatter: function (value) {
                      return dayjs(value).format('MMM YY');
                  },
                  style: {
                    fontWeight: '600',
                    colors: colors.text.primary,
                    paddingLeft:'20px',
                  },
              },
                axisBorder: {
                  show: false,
                },
                axisTicks: {
                  show: false,
                },
                tooltip:{
                  enabled:false
                }
              },
              colors: [colors.secondary.dark],
              fill: {
                type: 'gradient',
                colors: [colors.secondary.dark],
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100],
                },
              },
              grid: {
                show: true,
                // strokeDashArray: 10,
                // padding: {
                //   left: 20,
                //   right:25
                // }
              },
              stroke: {
                width: 2,
                curve: 'smooth', 
              },
              tooltip: {
                enabled: true,
                custom: function({ dataPointIndex}) {
                  const dataPoint = prices[dataPointIndex];  
                  const date = dayjs(dataPoint.x).format('MMM YYYY');
                  const price = `$ ${dataPoint.y.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
          
                  return `<div style="background-color: ${colors.background.paper}; padding: 5px 15px 0px; border-radius: 5px; text-align: center;">
                            <p style="font-weight:600;font-family:Inter;font-size:13px;letter-spacing:2%;color:${colors.text.primary};">${date}</p>
                            <p style="font-weight:600;font-family:Inter;font-size:13px;letter-spacing:2%;color:${colors.text.primary};">${price}</p>
                          </div>`;
                },
              },
            },
            series: [
              {
                data: localStorage.getItem('prices') ? JSON.parse(localStorage.getItem('prices')) : prices, 
              },
            ],
          };
          setGraphData(chartDatas)
        }else {
          setGraphData({});
        }
        },[prices,chartData])

        const resetToFirstDayOfMonth = (data) => {
          return data.map((item) => {
            const newDate = dayjs(item.date).startOf('month').format('YYYY-MM-DD');
            return { ...item, date: newDate }; 
          });
        };
      
        const getLastDayOfMonthData = (data) => {
          return data.reduce((acc, current) => {
            const currentDate = new Date(current.date);
            const yearMonth = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}`;
        
            if (!acc[yearMonth] || new Date(acc[yearMonth].date) < currentDate) {
              acc[yearMonth] = current;
            }
        
            return acc;
          }, {});
        };
    
        
      useEffect(() => {
        if (chartData?.length > 0 && isProductSubscribed) {
            const filtered = filterData(chartData, duration);
            if(chartData?.length >0 ) {
                const formattedData = filtered.map(item => ({
                x: item.date, 
                y: parseFloat(item.price)
                }));
                if(formattedData?.length == 1) {
                  let oneDate = formattedData[0]?.x
                  let dates =  dayjs(oneDate).subtract(1, 'month').format('YYYY-MM-DD')
                  formattedData?.unshift({x: dates, y:0})
                }
                setPrices(formattedData);
                localStorage.setItem('prices',JSON.stringify(formattedData))
            }
        }

        return() => {
            localStorage.removeItem('prices')
          }
      
      }, [chartData, duration,isProductSubscribed]);

      const filterData = (data, range) => {
        const singleDateForMonth = Object.values(getLastDayOfMonthData(data))
        const updatedCharty = resetToFirstDayOfMonth(singleDateForMonth);

        if(updatedCharty?.length > 0) {
        const now = dayjs(); 
        const filtered = updatedCharty?.filter(({ date }) => {
          const dataDate = dayjs(date); 
          
          if (range === '6 Months') {
            const sixMonthsAgo = now.subtract(6, 'month'); 
            return dataDate.isAfter(sixMonthsAgo); 
          } else if (range === '1 Year') {
            const oneYearAgo = now.subtract(1, 'year'); 
            return dataDate.isAfter(oneYearAgo); 
          }
        
          return false;
        });

        return filtered;
      } else {
        return []
      }
      };

      useEffect(() => {
        calculateWidth()
      },[timeline])


    const calculateWidth = () => {
        const arr = [];
        const widthPercent = timeline?.map((_, index) => ((100 / timeline?.length) * (index + 1)).toFixed(2));
      
        timeline?.forEach((item, index) => {
          const isCrossedDeadline = item?.deadline <= formattedToday;
          arr.push({
            isCrossedDeadline,
            widthPercent: widthPercent[index]
          });
        });
      
        const lastCrossedIndex = arr.map(item => item?.isCrossedDeadline).lastIndexOf(true);
      
        if (lastCrossedIndex === -1) return 0;
      
      const fullWidthPercent = parseFloat(arr[lastCrossedIndex].widthPercent) == 100.00 ?  parseFloat(arr[lastCrossedIndex].widthPercent) :  parseFloat(arr[lastCrossedIndex].widthPercent) + 10.00
        return fullWidthPercent;
      };

useEffect(() => {
    if(product?.name) {
        const r_type = product.tags.find(tag => tag.type);
        const r_lockingPeriod = product.tags.find(tag => tag.lockingPeriod)
        const r_metrics = product.tags.find(tag => tag.metrics)
        const r_video = product.tags.find(tag => tag.videoUrls)
        const r_disclaimer = product.tags.find(tag => tag.disclaimer)
        const r_iconUrl = product.tags.find(tag => tag.iconUrl)
        const r_sma = product.tags.find(tag => tag.sma)
        const r_timeline = product.tags.find(tag => tag.timeline)
        const factSheet = product.tags.find(tag => tag.factsheet)
        if(r_lockingPeriod) setLockingPeriod(r_lockingPeriod.lockingPeriod)
        if(r_type) setType(r_type.type)
        if(r_metrics?.metrics?.length >0) {
          const returnedLabel = changeRiskTypeName(r_metrics.metrics[0].riskRating)
          setRiskRating(returnedLabel)
        }
        if(r_metrics?.metrics?.length == 2) setProjectedReturns(r_metrics.metrics[1].projectedReturns)            
        if(r_video?.videoUrls.length > 0) setVideoUrl(r_video?.videoUrls)
        if(r_disclaimer?.disclaimer) setDisclaimer(r_disclaimer?.disclaimer)
        if(r_iconUrl?.iconUrl) {
          setIconUrl( r_iconUrl?.iconUrl ? r_iconUrl?.iconUrl : "https://assets.tradetogether.app/products/BitcoinAdvantage.svg")
        } else if(!r_iconUrl?.iconUrl) {
          setIconUrl("https://assets.tradetogether.app/products/BitcoinAdvantage.svg")
        }
        if(r_sma?.sma.isEligible) {
            setSma({isEligible: r_sma.sma.isEligible, description: r_sma.sma.description})
        }
        if(r_timeline?.timeline?.length > 0) {
          let conditionalText = r_timeline?.timeline?.filter(item => item.deadline && item.title)
          setTimeLine(conditionalText)
        } 
        if(factSheet) {
          setFactSheetUrl(factSheet?.factsheet)
        }
       
    }
},[product])
console.log("factSheetUrl ",factSheetUrl)

    return (
      <>
      <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
        {/* <Box sx={{ backgroundColor: colors.primary.contrastText, pb: 3,  borderRadius: '18px', width:"100%",  maxWidth:"1580px", }}> */}
        <MainLayout>
        <Box  height='auto'>
            <Box sx={{
                width:"100%",
                backgroundColor: colors.primary.contrastText,
                padding: {
                    sm: '20px 33px 35px 33px',
                    xs: '20px 15px 35px 15px'
                },
                borderRadius: '18px',
                boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                maxWidth:"1900px"

            }}>
                <>
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                    >
                        <Box sx={{ ...style, display: 'flex', }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center',   maxWidth:"524px", gap:{xs:"7px", sm:"9px", xl:"15px"} }}>
                            <Typography sx={{fontWeight:"500", fontSize:{xs:"24px",sm:"30px", lg:"30px", xxl:"35px"}, lineHeight:"60.34px", textAlign:"center", color:colors.text.primary, fontWeight:"600"}}>Unsubscribe product?</Typography>
                            <Button onClick={handleClose} sx={{ position: 'absolute', top: '15px', right: '10px', width: '100px' }}><ModalCloseIcon style={{}} /></Button>
                            <Box component='img' src={UnsubscribeIcon}  sx={{maxWidth:{xs:"180px",sm:"180px", lg:"190px", xll:"224.13px"}, maxHeight:{xs:"180px",sm:"200px",xl:"224.13px"}}}/>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                <Typography sx={{fontWeight:"500", fontSize:{xs:"20px",sm:"26px", lg:"26px", xll:"32.82px"}, lineHeight:"41.25px", textAlign:"center", color: colors.text.primary, fontWeight:"600"}}>Are you sure you want to unsubscribe the product “Stable Growth Staking”?</Typography>
                                <Typography sx={{fontWeight:"500", fontSize:{xs:"16px",sm:"18px", lg:"18px", xll:"19.21px"}, lineHeight:"26.9px", textAlign:"center", color:colors.text.secondary,fontWeight:"500"}}>This action cant be undone</Typography>
                            </Box>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px", width:"100%"}}>
                                <PrimaryButton variant="danger" onClick={handleUnsubscribe} sx={{ fontWeight:"500", mt:'10px' }}>
                                Confirm Unsubscribe
                                </PrimaryButton>
                                <Button  onClick={handleClose} sx={{mt:'10px',width:'100%', fontSize: '15px', height: '42px', padding: '2px 20px 2px 20px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: colors.text.secondary, backgroundColor:  colors.background.default, '&:hover': {backgroundColor:colors.background.default } }} >
                                Cancel Subscribing
                                </Button>
                            </Box>
                            </Box>
                        </Box>
                        </Box>
                    </Modal>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection:'Column',  background:colors.primary.contrastText, gap:'20px' }}>
                            {!isProductSubscribed ? 
                            // <Box sx={{display:"flex", alignItems:"center", justifyContent: factSheetUrl ? 'space-between' : 'flex-start', width:"100%"}}> 
                            // <IconButton onClick={() => navigate(-1)} sx={{display:'flex', width:'fit-content', alignItems:'center', gap:'11.18px', padding:'10px', pl:'0',  borderRadius:'22px'}}>
                            //         <Box component='img' src={BackArrow}/>
                            //         <Typography sx={{fontSize:'14px', color:colors.text.secondary, fontWeight:'500', lineHeight:'18.73px', letterSpacing:'5%'}}>Back</Typography>
                            //     </IconButton>
                            //     {factSheetUrl && (
                            //       <Box sx={{ display: 'flex', justifyContent:"center", gap: '5px', }}>
                            //         {!loading ? (
                            //          <Button
                            //             variant="contained"
                            //             component="a"
                            //             href={factSheetUrl}
                            //             target="_blank"
                            //             download
                            //             sx={{
                            //               display: "flex",
                            //               justifyContent: "center",
                            //               alignItems: "center",
                            //               gap: "10px",
                            //               backgroundColor: colors.background.default,
                            //               color: colors.text.primary,
                            //               padding: "14px 20px",
                            //               borderRadius: "100px",
                            //               textTransform: "none",
                            //               fontWeight: "bold",
                            //               fontSize: "13px",
                            //               boxShadow: "none",
                            //               "&:hover": {
                            //                 backgroundColor: colors.background.elevated,
                            //                 boxShadow: "none",
                            //               },
                            //             }}
                            //           >
                            //             <Box component="img" src={PdfIcon} />
                            //             Download Factsheet
                            //           </Button>

                            //         ) : (
                            //           <ShimmerSkeleton sx={{ width: '50%', height: '20px' }} />
                            //         )}
                            //       </Box>
                            //     )}
                            //     </Box> 
                            <Typography sx={{display:{xs:"none", sm:"block"},fontSize:{xs:"23.99px", sm:"24px", xl:'26px'}, color: colors.text.primary, fontFamily:'Inter', fontWeight:'550', lineHeight:'30px', letterSpacing:'0.02em'}}>Product Details</Typography>
                                 : (<>
                                    <Typography sx={{display:{xs:"block", sm:"none"}, fontSize:{xs:"23.99px", sm:"24px", xl:'26px'}, color:colors.text.primary, fontWeight:'500', lineHeight:'30px', letterSpacing:'0.02em', textAlign: isProductSubscribed ? "center" : "left"}}>{ isProductSubscribed ? 'Add Product' : 'Subscribe Product'}</Typography>
                                    <Typography sx={{display:{xs:"none", sm:"block"},fontSize:{xs:"23.99px", sm:"24px", xl:'26px'}, color:colors.text.primary, fontWeight:'550', lineHeight:'30px', letterSpacing:'0.02em'}}>Product Details</Typography>
                                    </>
                                )}
                                <Box sx={{display:'flex', justifyContent:'space-between', flexDirection:{xs:"column", md:"row"}, gap:{xs:"40px", md:"0px"}}}>
                                    <Box sx={{display:'flex', maxWidth:"460px", flexDirection:'column', gap:'15px',width:{xs:"100%",md:'50%'}}}>
                                        <Box sx={{display:{xs:"none",md:"flex"}, flexDirection:"column", gap:"10px"}}>
                                            {!loading ? <Typography sx={{fontSize:{xs:"22.35px", sm:"22px", xl:'24px'}, color:colors.text.primary, fontWeight:'500', lineHeight:'38px', letterSpacing:'0.5%'}}>{product?.name}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                            {!loading ? <Typography  color='Grey' sx={{ fontSize:'14px', lineHeight:'24px', letterSpacing:'0.5px',}}>{product?.description}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"80px"}} />}
                                        </Box>
                                        <Box sx={{display:{xs:"flex", md:"none"}, gap:"10px"}}>
                                            <Box sx={{height:{xs:'75.4px',sm:'90px'}, width:{xs:'75.4px',sm:'90px'}, scale:"1.5"}} >
                                              {!loading ? <Box component='img' sx={{height:"60px", width:"50px"}}  src={ iconUrl} /> :<Skeleton variant="circular" sx={{alignSelf:"flex-end"}} width={40} height={40} />}
                                            </Box>
                                            <Box sx={{display:"flex", flexDirection:"column", gap:"10px"}}>
                                                {!loading ? <Typography sx={{fontSize:{xs:"18px", sm:"22px", xl:'24px'}, color:colors.text.primary, fontWeight:'700', lineHeight:'30px', letterSpacing:'0.02em'}}>{product?.name}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />} 
                                                {!loading ?  <Typography  color='Grey' sx={{fontSize:'14px', lineHeight:'17.6px', letterSpacing:'5%',}}>{product?.description}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"80px"}} />}
                                            </Box>
                                        </Box>
                                        <hr style={{border:`1px solid ${colors.border.default}`}}/>
                                        <Box sx={{display:'flex', flexDirection:'column', gap:'10px'}}>
                                            <Box sx={{display:'flex', justifyContent:"space-between", width:'100%'}}>
                                                <Box sx={{display:'flex', flexDirection:'column', gap:'5px',flex:1}}>
                                                    <Typography variant='h6' color='Grey' sx={{}}>Asset type</Typography>
                                                    {!loading ? <Typography  color='Grey' sx={{fontWeight: 550, fontSize:'13px', color:colors.text.primary,textAlign:"left"}}>{type}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                                </Box>
                                                <Box sx={{display:'flex', flexDirection:'column', gap:'5px',flex:1}}>
                                                    <Typography variant='h6' color='Grey' sx={{}}>Apy yield</Typography>
                                                    {!loading ? <Typography  color='Grey' sx={{fontWeight: 550, fontSize:'13px', color:colors.text.primary, textAlign:"left"}}>{product?.expectedYield} %</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                                </Box>
                                                <Box sx={{display:'flex', flexDirection:'column', gap:'5px',flex:1}}>
                                                    <Typography variant='h6' color='Grey' sx={{}}>Locking Period</Typography>
                                                    {!loading ? <Typography  color='Grey' sx={{fontWeight: 550, fontSize:'13px', color:colors.text.primary,textAlign:"left"}}>{lockingPeriod ? `${lockingPeriod} months`  : '-'}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                                </Box>
                                            </Box>
                                            <Box sx={{display:'flex', justifyContent:"space-between", width:'100%'}}>
                                                <Box sx={{display:'flex', flexDirection:'column', gap:'5px',flex:1}}>
                                                    <Typography variant='h6' color='Grey' sx={{}}>Risk Rating</Typography>
                                                    {!loading ? <Typography  color='Grey' sx={{fontWeight: 550, fontSize:'13px', color:colors.text.primary,textAlign:"left"}}>{riskRating ? riskRating : '-'}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                                </Box>
                                                <Box sx={{display:'flex', flexDirection:'column', gap:'5px',flex:1}}>
                                                    <Typography variant='h6' color='Grey' sx={{}}>Project</Typography>
                                                    {!loading ? <Typography  color='Grey' sx={{fontWeight: 550, fontSize:'13px', color:colors.text.primary,textAlign:"left"}}>{projectedReturns ? `${projectedReturns} %` : "-"}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                                </Box>
                                                <Box sx={{display:'flex', flexDirection:'column', gap:'5px',flex:1}}>
                                                    <Typography variant='h6' color='Grey' sx={{}}>Time Period</Typography>
                                                    {!loading ? <><Typography  color='Grey' sx={{fontWeight: 550, fontSize:'13px', color:colors.text.primary,textAlign:"left"}}>{product?.tenor < 10000000 && `${product?.tenor} months`}</Typography> 
                                                    {product?.tenor > 10000000 && <Box component={'img'} src={InfiniteIcon} sx={{height:"15px",width:"30px"}}/>}</> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                                </Box>
                                            </Box>

                                    </Box>
                                    </Box>
                                    <Box sx={{display:'flex',  flexDirection:'column', gap:'15px',width:{xs:"100%",md:'50%'}, maxWidth:"393px", alignSelf:{xs:"center"}, alignItems:'flex-end'}}>
                                        <Box  sx={{display:{xs:"none", md:"inline-block"}, height:{xs:'75.4px',sm:'90px'}, width:{xs:'75.4px',sm:'90px'}, scale:"1.5"}} >
                                          {!loading ? <Box component='img' sx={{height:"100%", width:"100%"}} src={ iconUrl} /> : <Skeleton variant="circular" sx={{alignSelf:"flex-end"}} width={40} height={40} />}
                                        </Box>
                                        {/* <Box component='img' sx={{display:{xs:"none", md:"inline-block"}, height:{xs:'75.4px',sm:'90px'}, width:{xs:'75.4px',sm:'90px'}}} src={ iconUrl} /> */}
                                        {!isProductSubscribed ? (
                                          <PrimaryButton
                                            disabled={!onboardingStatusText}
                                            onClick={handleSubscribe}
                                            variant='outlined'
                                            sx={{
                                              mt:'10px',
                                              ...(isSubscribeClicked ? {
                                                backgroundColor: "transparent",
                                                color: colors.text.primary,
                                                border: `1.5px solid ${colors.primary.main}`,
                                                '&:hover': { backgroundColor: "transparent" },
                                              } : {}),
                                            }}
                                          >
                                                {isSubscribeClicked ? "Cancel Subscribing" : "Subscribe"}
                                        </PrimaryButton>
                                        // <Button  onClick={handleSubscribe} sx={{maxWidth:"393px", mt:'10px',width:'100%', fontSize: '15px', height: '42px', padding: '2px 20px 2px 20px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: isSubscribeClicked ? colors.text.primary : colors.primary.contrastText, backgroundColor: isSubscribeClicked ? colors.background.default : colors.primary.main, '&:hover': {backgroundColor:isSubscribeClicked ? colors.background.default : colors.primary.main} }} variant= {onboardingStatusText ? '' : 'contained'} >
                                        //         {isSubscribeClicked ? "Cancel Subscribing" : "Subscribe"}
                                        // </Button>
                                      ) : (<>
                                        <PrimaryButton colorVariant="danger" onClick={handleUnsubscribe} sx={{ mt: '10px' }}>
                                          Unsubscribe
                                        </PrimaryButton>

                                        <PrimaryButton colorVariant="success"  sx={{ mt: '10px' }}>
                                          Top Up to Product
                                        </PrimaryButton>
                                           {/* <Button  disabled variant='contained' sx={{maxWidth:"393px", fontWeight:"500", mt:'10px',width:'100%', fontSize: '15px', height: '42px', padding: '2px 20px 2px 20px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: colors.primary.contrastText, }} >
                                            Unsubscribe
                                        </Button>
                                        <Button  disabled variant='contained' sx={{maxWidth:"393px", fontWeight:"500", mt:'10px',width:'100%', fontSize: '15px', height: '42px', padding: '2px 20px 2px 20px', borderRadius: '8px !important', letterSpacing: '.6px', p:"10px", color: colors.primary.contrastText, }} >
                                            Top Up to Product
                                        </Button> */}
                                        </>)}
                                        { !isProductSubscribed && sma.isEligible && <Box sx={{width:"100%",display:'flex',justifyContent:'flex-start', alignItems:'center', gap:'10px', mt:'10px', boxShadow: `0px 1px 5px 0px #00000026`, padding:"12px", borderRadius:"12px" }}>
                                            <Box>
                                                <Box
                                                component='img'
                                                src={Protection}
                                                />
                                            </Box>
                                        
                                            <Box sx={{display:'flex', flexDirection:'column'}}>
                                                <Typography sx={{ fontWeight: '700 !important', color:colors.text.primary, fontSize:'14px' }}>Separated Managed Account</Typography>
                                                {!loading ? <Typography variant='h6' color='Grey' sx={{}}>{sma.description}</Typography> : <ShimmerSkeleton  sx={{width:"50%", height:"20px"}} />}
                                            </Box>
                                        </Box>}
                                        </Box>
                                    
                                </Box>
                            {!loading ?
                            
                            <>{isProductSubscribed &&
                            <>
                            { chartData?.length > 0 && 
                            <Box sx={{display:"flex", justifyContent:"space-between"}}>
                            <Typography sx={{fontSize:{xs:"14.99px", sm:"22px", xl:'24px'}, color:{xs:colors.text.secondary,sm:colors.text.primary}, fontWeight:'700', lineHeight:'30px', letterSpacing:'2%', mt:3, textAlign:{xs:"center", sm:"left"}}}>Market Overview</Typography>
                              <Box
                                sx={{
                                  display: chartData?.length > 0 ? 'flex' : 'none',
                                  alignItems: 'flex-start',
                                  justifyContent: { xs: 'center' },
                                  marginTop: { xs: '19px', md: '0px' },
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={0.5}
                                  sx={{
                                    alignSelf: "center",
                                    justifyContent: "center",
                                    backgroundColor: colors.background.paper,
                                    boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                                    borderRadius: '30px',
                                    padding: '5px',
                                    paddingTop: { xs: '24px', md: '5px' },
                                    '@media(max-width:990px)': {
                                      paddingTop: "24px"
                                    }
                                  }}
                                >
                                  <Button
                                    onClick={() => handleDuration('6 Months')}
                                    disableElevation
                                    sx={{
                                      minWidth: "85px",
                                      borderRadius: '25px',
                                      textTransform: 'none',
                                      fontWeight: duration == '6 Months' ? 600 : 500,
                                      color: duration == '6 Months' ? colors.primary.contrastText : colors.text.secondary,
                                      backgroundColor: duration == '6 Months' ? colors.primary.main : 'transparent',
                                      boxShadow: 'none',
                                      '&:hover': {
                                        backgroundColor: duration == '6 Months' ? colors.primary.main : 'transparent',
                                      },
                                    }}
                                  >
                                    6 Months
                                  </Button>
                                  <Button
                                    onClick={() => handleDuration('1 Year')}
                                    disableElevation
                                    sx={{
                                      minWidth: "85px",
                                      borderRadius: '25px',
                                      textTransform: 'none',
                                      fontWeight: duration == '1 Year' ? 600 : 500,
                                      color: duration == '1 Year' ? colors.primary.contrastText : colors.text.secondary,
                                      backgroundColor: duration == '1 Year' ? colors.primary.main : 'transparent',
                                      boxShadow: 'none',
                                      '&:hover': {
                                        backgroundColor: duration == '1 Year' ? colors.primary.main : 'transparent',
                                      },
                                    }}
                                  >
                                    1 Year
                                  </Button>
                                </Stack>
                              </Box>
                              </Box>}
                              
                            <Box component='div' width='100%' height='100%' mt={1} className="apexcharts-xaxis-texts-g custom-xaxis-shift">
                                    {graphData?.options?.chart ? <Chart options={graphData?.options} series={graphData?.series} type="area" width="100%" height='400px' /> : 
                                    <EmptyChart/>
                                    }
                                </Box> 

                                </>
                                }</> : <Box sx={{width:"100%", height:"400px", display:"flex", justifyContent:"center", alignItems:"center"}}><CircularProgress disableShrink   /></Box>}
                                {(timeline?.length > 0 && !isSubscribeClicked) && 
                            <Box
                            sx={{
                              width: '100%',
                              my: 4,
                              overflowX: 'auto', // Enable horizontal scrolling
                              maxWidth: '100%',
                              whiteSpace: 'nowrap', // Prevent line breaks
                            //   scrollbarWidth: 'thin', // For Firefox
                              '::-webkit-scrollbar': {
                                height: '8px', // Set the height for horizontal scrollbar
                              },
                              '::-webkit-scrollbar-thumb': {
                                borderRadius: '10px', // Rounded corners
                                backgroundColor: colors.text.secondary,
                              },
                              '::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: colors.text.primary,
                              },
                              '::-webkit-scrollbar-track': {
                                backgroundColor: colors.neutral.shimmerLight,
                              },
                            }}
                          >
                            <Box
                              sx={{
                                minWidth: '100%',
                                width: `${timeline.length * 200}px`, // Adjust width based on timeline length
                                mx: 'auto',
                              }}
                            >
                              <Box sx={{ width: '100%', height: '66px', mb: 2, display:"flex", alignItems:"flex-end" }}>
                                <Box
                                  sx={{
                                    height: '38px',
                                    backgroundColor: colors.background.default,
                                    width: '100%',
                                    position: 'relative',
                                    '&::before, &::after': {
                                      content: '""',
                                      position: 'absolute',
                                      height: '150%', // Extend beyond the height of the box
                                      width: '2px',
                                      backgroundColor: calculateWidth() === 100.00 ? 'transparent' : colors.text.primary,
                                    },
                                    '&::before': {
                                      left: 0,
                                      bottom: '0', // Adjust to extend above and below the box
                                    },
                                    '&::after': {
                                      right: 0,
                                      bottom: '0', // Adjust to extend above and below the box
                                    },
                                  }}
                                >
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      left: 0,
                                      height: '100%',
                                      backgroundColor: calculateWidth() === 0 ? 'transparent' : colors.primary.main,
                                      width: `${calculateWidth()}%`,
                                      '&::before, &::after': {
                                        content: '""',
                                        position: 'absolute',
                                        width: '2px',
                                        height: '150%', // Extend beyond the height of the box
                                        backgroundColor: calculateWidth() === 0 ? 'transparent' : colors.primary.main,
                                      },
                                      '&::before': {
                                        left: 0,
                                        bottom: '0', // Adjust to extend above and below the box
                                      },
                                      '&::after': {
                                        right: 0,
                                        bottom: '0', // Adjust to extend above and below the box
                                      },
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Box>
                            <TimelineView timeline={timeline} />
                          </Box>
                          
                            }
                            {disclaimer !='' && <Box sx={{display:'flex',gap:'10px', border:`1px solid ${colors.border.default}`, padding:'10px', my:4, borderRadius:'12px'}}>
                                    <Box 
                                    component='img'
                                    src={Disclaimer}
                                    sx={{width:'32px', height:'32px'}}
                                    />
                                    <Box sx={{display:'flex', flexDirection:'column', gap:'10px', width:"100%"}}>
                                        <Typography sx={{ fontWeight: '500',color:colors.text.primary, fontSize:'16px', lineHeight:'20px', letterSpacing:'2%' }}>Disclaimer</Typography>
                                        <Typography sx={{fontSize:'14px', lineHeight:'17.6px', letterSpacing:'5%', width:'90%', color: colors.text.gray}}>{ disclaimer}</Typography>
                                    </Box>
                                </Box>}
                            {(videoUrl?.filter(url => url.trim() !== '')?.length >0 && !isSubscribeClicked) && <Box sx={{display:'flex', width:"100%", flexDirection:{xs:"column", lg:"row"}, justifyContent:'space-between', mt: disclaimer  ? 0 : 4, gap:"10px"}}>
                                
                            {videoUrl?.filter(url => url.trim() !== '').length > 0 && ( videoUrl?.length !== 1 ?
                              <Grid container spacing={2}>
                                {videoUrl?.map((item, index) => (
                                  <Grid
                                    item
                                    key={index}
                                    xs={12}       // 1 video on xs and sm
                                    lg={6}        // 2 videos per row on lg
                                    xl={6} 
                                    xxl={4}        // 3 videos per row on xl
                                  >
                                    <Box
                                      sx={{
                                        position: 'relative',
                                        width: '100%',
                                        height: { xs: '320px', md: '500px' },
                                      }}
                                    >
                                      <iframe
                                        style={{
                                          left: 0,
                                          top: 0,
                                          height: '100%',
                                          width: '100%',
                                          position: 'absolute',
                                          borderRadius: '12px',
                                        }}
                                        src={`https://www.youtube.com/embed/${getId(item)}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title={`Embedded youtube ${index}`}
                                      />
                                    </Box>
                                  </Grid>
                                ))}
                              </Grid> : (
                                 videoUrl?.map((item, index) => (
                                 
                                    <Box
                                      sx={{
                                        position: 'relative',
                                        width: '100%',
                                        height: { xs: '320px', md: '500px' },
                                      }}
                                    >
                                      <iframe
                                        style={{
                                          left: 0,
                                          top: 0,
                                          height: '100%',
                                          width: '100%',
                                          position: 'absolute',
                                          borderRadius: '12px',
                                        }}
                                        src={`https://www.youtube.com/embed/${getId(item)}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title={`Embedded youtube ${index}`}
                                      />
                                    </Box>
                                ))
                              )
                            )}

                            </Box>}

                          
                            {isSubscribeClicked && 
                            <Box>
                              <Box sx={{display:"flex", justifyContent:"space-between", flexDirection:{xs:"column-reverse",sm:"row"}, gap:2, alignItems:"center" }}>
                                <Typography sx={{color: colors.secondary.navy, fontSize:'17px', mb:1, fontWeight:"500"}}>Subscription Form</Typography>
                                <IdleCashField idleCash={idleCash} />
                              </Box>
                              <Box sx={{display:"flex", gap:"20px", flexDirection:{xs:"column", md:"row"}}}>                                    
                                      <Box sx={{ width:{xs:"100%",md:"50%"} }}>
                                          <TextField
                                              name="investedAmt"
                                              placeholder='Enter investment amount (Min $100)'
                                              value={formValues.investedAmt}
                                              onChange={handleChange}
                                              variant="outlined"
                                              fullWidth
                                              error={Boolean(formErrors?.investedAmt)}
                                              // helperText={`Idle Cash: $ ${idleCash}` || ""}
                                              inputProps={{ inputMode: 'decimal', pattern: '[0-9.]*', maxLength: 10 }}
                                              sx={{                                              
                                                  '& fieldset': { border: formErrors?.investedAmt ? `1px solid ${colors.error.main}` :  `1px solid ${colors.border.cardDiv}` }, borderRadius:"8px"
                                              }}
                                          />
                                        <Typography sx={{fontSize:"0.75rem", color:colors.primary.main,fontWeight:"500", mb: 1,mt:'5px'}}>Idle Cash Available: $ {idleCash}</Typography>
                                          <StyledErrorText sx={{mt:"5px"}}>{formErrors?.investedAmt}</StyledErrorText>

                                          <FormControl fullWidth sx={{ mb: 2, border:  `1px solid ${colors.border.cardDiv}`, '& fieldset': { border: 'none' },borderRadius:"8px" }}>
                                              <Select
                                                  name="allocationType"
                                                  placeholder='Select type of allocation'
                                                  value={formValues.type}
                                                  onChange={handleChange}
                                                  displayEmpty
                                                  renderValue={(selected) => {
                                                  if (!selected) {
                                                      return <Typography sx={{color:colors.text.secondary, fontSize:"14px"}}>Select type of allocation</Typography>;
                                                  }
                                                  return selected;
                                                  }}
                                              >
                                                  <MenuItem  value="Conservative">Conservative</MenuItem><Divider />
                                                  <MenuItem value="Balanced">Balanced</MenuItem><Divider />
                                                  <MenuItem value="Aggressive">Aggressive</MenuItem>
                                              </Select>
                                          </FormControl>
                                          <StyledErrorText sx={{mt:"-10px"}}>{formErrors?.allocationType}</StyledErrorText>

                                          <TextField
                                              name="productName"
                                              placeholder='Custom Product Name (optional)'
                                              value={formValues.productName}
                                              onChange={handleChange}
                                              variant="outlined"
                                              fullWidth
                                              sx={{
                                                  mb: 2,
                                                  border:  `1px solid ${colors.border.cardDiv}`,
                                                  '& fieldset': { border: 'none' }, 
                                                  borderRadius:"8px"
                                              }}
                                          />

                                              <TextField
                                                  name="productDescription"
                                                  placeholder='Custom Product Description (optional)'
                                                  value={formValues.productDescription}
                                                  onChange={handleChange}
                                                  variant="outlined"
                                                  fullWidth
                                                  multiline
                                                  rows={5}
                                                  sx={{
                                                      border:  `1px solid ${colors.border.cardDiv}`,
                                                      '& fieldset': { border: 'none' },
                                                      borderRadius:"8px"
                                                  }}
                                              />
                                          
                                      </Box>
                                      <Box sx={{width:{xs:"100%",md:"50%"}, alignSelf:{xs:"center",md:"flex-end"},justifyContent:{xs:"center",md:"flex-end"}, height:"100%", display:"flex"}}>
                                          <PrimaryButton disabled={isSubscribeDisabled} onClick={handleSubmit} sx={{ mt:'10px' }}>
                                              Confirm Subscription
                                          </PrimaryButton>
                                          {/* backgroundColor: colors.primary.main, '&:hover': {backgroundColor:colors.primary.main} */}
                                      </Box>
                              </Box>
                            </Box>
                            }
                            </Box >
                        </Box>
                    </Box>
                </>
            </Box>
        </Box>
    </MainLayout>
   </>
    )
}



// {videoUrl?.filter(url => url.trim() !== '')?.length >0 && videoUrl?.map((item, index) => (
//   <Box key={index} sx={{  position:'relative', width:{xs:'100%',lg:'45%'}, width:"100%", height:{xs:'320px', md:"500px"},}}>
//       <iframe
//       style={{left:0,top:0,height:'100%',width:'100%', position:'absolute', borderRadius:'12px'}}
//       width="468px"
//       src={`https://www.youtube.com/embed/${getId(item)}`}
//       frameBorder="0"
//       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//       allowFullScreen
//       title="Embedded youtube"
//       />
//   </Box>
// ))}